<glxy-confirmation-body>
  <mat-icon glxyConfirmationIcon class="icon confirm" inline="true" color="primary">info</mat-icon>
  <glxy-confirmation-title>{{
    'LIB_ORDERS.COMMON.ORDERS.DIALOGS.DECLINE_ORDER_CANCELLATION.TITLE' | translate
  }}</glxy-confirmation-title>

  <glxy-confirmation-message>
    {{ 'LIB_ORDERS.COMMON.ORDERS.DIALOGS.DECLINE_ORDER_CANCELLATION.MESSAGE' | translate }}
  </glxy-confirmation-message>
  <glxy-confirmation-custom-content>
    <b>{{ 'LIB_ORDERS.COMMON.ORDERS.DIALOGS.DECLINE_ORDER_CANCELLATION.LABEL' | translate }}</b>
    <glxy-badge class="required-badge" size="small">{{
      'LIB_ORDERS.COMMON.ORDERS.DIALOGS.DECLINE_ORDER_CANCELLATION.REQUIRED' | translate
    }}</glxy-badge>
    <div class="cancellation-reason-container">
      <glxy-form-field class="notes-input">
        <textarea matInput [(ngModel)]="notes" required></textarea>
      </glxy-form-field>
    </div>
    <div class="subnotes">
      {{ 'LIB_ORDERS.COMMON.ORDERS.DIALOGS.DECLINE_ORDER_CANCELLATION.SUBNOTES' | translate }}
    </div>
  </glxy-confirmation-custom-content>
</glxy-confirmation-body>

<glxy-confirmation-actions>
  <glxy-confirmation-primary-actions>
    <button mat-stroked-button (click)="onDontCancel()">
      {{ 'LIB_ORDERS.COMMON.ACTION_LABELS.CLOSE' | translate }}
    </button>
    <button mat-flat-button color="primary" [disabled]="!notes" (click)="onCancel()">
      {{ 'LIB_ORDERS.COMMON.ORDERS.DIALOGS.DECLINE_ORDER_CANCELLATION.DECLINE_REQUEST' | translate }}
    </button>
  </glxy-confirmation-primary-actions>
</glxy-confirmation-actions>
